import { lazy } from "react";
import Loadable from "../../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../../constants/enums";

const DriverProfileList = Loadable(
  lazy(() =>
    import("./DriverProfileList").then(({ DriverProfileList }) => ({
      default: DriverProfileList,
    }))
  )
);

const DriverProfileForm = Loadable(
  lazy(() =>
    import("./DriverProfileForm").then(({ DriverProfileForm }) => ({
      default: DriverProfileForm,
    }))
  )
);

export const commAutoDriverProfileRouter = [
  {
    path: `/comm-automobile-policy/:customerId/driver-profile-tab/:customerPolicyId`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <DriverProfileList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/comm-automobile-policy/:customerId/driver-profile-tab/:customerPolicyId/form`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <DriverProfileForm />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/comm-automobile-policy/:customerId/driver-profile-tab/:customerPolicyId/form/:incrementalNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <DriverProfileForm />
      </AuthorizedRoute>
    ),
  },
];
